import getColor from "@insite/mobius/utilities/getColor";
import { headerSignInStyles as styles } from "@tggstore/Overrides/Widgets/Common/HeaderSignIn";
import { colorStrings } from "@tggstore/Utilities/variables";
import { css } from "styled-components";

styles.titleTypography = {
    ...styles.titleTypography,
    size: 18,
    color: colorStrings.textMain,
    transform: "none",
    css: css`
        ${styles.titleTypography?.css}
        min-width: max-content;
        max-width: auto;
        margin: 0;
    `,
};

styles.signOutClickable = {
    ...styles.signOutClickable,
    css: css`
        ${styles.signOutClickable?.css}
        text-transform: none;
    `,
};

styles.linksWrapper = {
    ...styles.linksWrapper,
    css: css`
        ${styles.linksWrapper?.css}
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 5px;
        padding: 0 5px;

        .list-link span {
            color: ${getColor(colorStrings.textMain)};
        }
    `,
};

styles.myAccountIcon = {
    ...styles.myAccountIcon,
    size: 20,
};
